import { render, staticRenderFns } from "./template.vue?vue&type=template&id=3c5d0eee&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"
import style0 from "./template.vue?vue&type=style&index=0&id=3c5d0eee&scoped=true&lang=scss"
import style1 from "./template.vue?vue&type=style&index=1&id=3c5d0eee&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d0eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5d0eee')) {
      api.createRecord('3c5d0eee', component.options)
    } else {
      api.reload('3c5d0eee', component.options)
    }
    module.hot.accept("./template.vue?vue&type=template&id=3c5d0eee&scoped=true", function () {
      api.rerender('3c5d0eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/template/components/template.vue"
export default component.exports